"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _profile = require("@widget/profile");

var _navigate = require("@wrapper/navigate");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Header = _interopRequireDefault(require("./Header"));

var _Navigate = _interopRequireDefault(require("./Navigate"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _slice = require("../store/slice");

function NavigateWrapper(_ref) {
  var children = _ref.children;

  try {
    var handleOpen = function handleOpen() {
      dispatch((0, _navigate.switchNavigate)(true));
    };

    var handleClose = function handleClose() {
      dispatch((0, _navigate.switchNavigate)(false));
    };

    var navigateRef = (0, _react.useRef)(null);
    var dispatch = (0, _reactRedux.useDispatch)();
    var isOpen = (0, _reactRedux.useSelector)(_navigate.selectIsOpen);
    var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);
    var inProcess = (0, _reactRedux.useSelector)(_navigate.selectInProcess);
    (0, _react.useEffect)(function () {
      return function () {
        dispatch((0, _slice.resetStateAction)());
      };
    }, []);

    if (!profile) {
      return null;
    }

    var asideClassName = (0, _classnames["default"])(_defaultModule["default"]['aside'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['aside--open'], isOpen));
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: _defaultModule["default"]['display']
    }, /*#__PURE__*/_react["default"].createElement("header", {
      className: _defaultModule["default"]['header']
    }, /*#__PURE__*/_react["default"].createElement(_Header["default"], null)), /*#__PURE__*/_react["default"].createElement("section", {
      className: _defaultModule["default"]['display__content']
    }, /*#__PURE__*/_react["default"].createElement("aside", {
      className: asideClassName,
      onMouseEnter: function onMouseEnter() {
        return handleOpen();
      },
      onMouseMove: function onMouseMove() {
        return handleOpen();
      },
      onMouseLeave: function onMouseLeave() {
        return handleClose();
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      ref: navigateRef,
      className: _defaultModule["default"]['aside__content']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['navigate']
    }, /*#__PURE__*/_react["default"].createElement(_Navigate["default"], null))))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['container']
    }, /*#__PURE__*/_react["default"].createElement("section", {
      id: "scroll",
      className: _defaultModule["default"]['content']
    }, children), inProcess && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['loading'],
      "data-locator": "page.loader"
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Spinner, null)))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = NavigateWrapper;
exports["default"] = _default;